import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerCategoriesPage from "../pages/DsokCustomerCategoriesPage";

export const dsokCustomerCategoriesRoute = {
  path: "/dsok/customer-detail/:customerUrl/categories",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerCategoriesPage} />
    </DsokCustomerDetailProvider>
  ),
};
